import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
import { CallType } from '@weblite/ts-action/media-proxy'
import { CallFeedbackType, CallFeedback } from './call-feedback'

const COMPONENT_ID = 'callFeedback'

const showCallFeedback = (props: Parameters<typeof CallFeedback>[0]) =>
  addModal({ id: COMPONENT_ID, props })

export const showCallFeedbackDialog = (
  callType: CallType,
): Promise<CallFeedbackType> =>
  new Promise(resolve =>
    showCallFeedback({
      onConfirm: async feedBack => {
        await closeCurrentModal()
        resolve(feedBack)
      },
      callType,
    }),
  )

export default {
  [COMPONENT_ID]: {
    Component: CallFeedback,
  },
}
